import React from "react";
import "./Privacy.css";

function Privacy() {
  return (
    <div className="privacy_container">
      <h1 className="privacy-header"> Privacy Policy </h1>
      <p>
        {" "}
        We know that you care how your information is used, and we appreciate
        you trust that we will use it carefully and sensibly. This notice
        describes our privacy policy. By visiting us, you are accepting the
        privacy policy described below.{" "}
      </p>

      <article>
        <h2 className="privacy-title">
          {" "}
          1. What Personal Information Do We Collect?{" "}
        </h2>
        <p>
          <strong>Information You Provide</strong>. We receive and store
          information you enter. For example, when you search for or buy a
          product or service, or when you supply information such as your
          address, phone number or credit card. You can choose not to provide
          certain information, but then you might not be able to take advantage
          of some of our features. We use the information that you provide for
          such purposes as responding to your requests, customizing future
          shopping for you, improving our website, and communicating with you.
          In addition, if you choose, we may share your information with other
          companies who provide goods or services that you are interested in.
        </p>
        <p>
          <strong>Cookies.</strong> Like many websites, we use “cookies”.
          Cookies are small programs that we transfer to your hard drive that
          allow us to recognize you and to provide you with a customized
          shopping experience. If you do not want us to use cookies, you can
          easily disable them by going to the toolbar of your web browser, and
          clicking on the “help” button. Follow the instructions that will
          prevent the browser from accepting cookies, or set the browser to
          inform you when you receive a new cookie. In addition, you may visit
          this and other websites anonymously through the use of utilities
          provided by other private companies.
        </p>
        <p>
          <strong>Other Information:</strong> Every computer has an IP (Internet
          Protocol) address. IP addresses of computers used to visit this site
          are noted. In addition, we automatically collect other information
          such as email addresses, browser types, operating systems, and the URL
          addresses of sites clicked to and from this site.
        </p>
        <p>
          <strong>Information from Other Sources.</strong> We might receive
          information about you from other sources and add it to our account
          information. This may include updated delivery and address information
          from our shippers or other sources so that we can correct our records
          and deliver your next purchase or communication more easily.
        </p>
      </article>
      <article>
        <h2 className="privayc-title">2. How Do We Use Your Information?</h2>
        <p>
          <strong>Agents.</strong> We may employ other companies and individuals
          to perform functions on our behalf. Examples include delivering
          packages, sending postal mail and e-mail, and processing credit card
          payments. They have access to personal information needed to perform
          their functions, but may not use it for other purposes.{" "}
        </p>
        <p>
          <strong>Business Transfers</strong>. As we continue to develop our
          business, we might sell or buy stores or assets. In such transactions,
          customer information generally is one of the transferred business
          assets. Also, in the unlikely event that we are acquired, customer
          information will be one of the transferred assets.
        </p>
        <p>
          <strong>Law Enforcement</strong>. If we receive a lawful court order
          to release account or other personal information then we will comply
          with the law. We will also release information when necessary to
          protect the life, safety or property of others. This includes
          exchanging information with other companies and organizations for
          fraud protection and credit risk reduction.
        </p>
      </article>
      <article>
        <h2 className="privacy-title">
          3. How Do We Protect the Security of Your Information?
        </h2>
        <ul>
          <li>
            We work to protect the security of your information during
            transmission by using Secure Sockets Layer (SSL) software, which
            encrypts information you input.
          </li>
          <li>
            We use encryption to protect your information contained in our
            customer list.
          </li>
          <li>We use a firewall to protect against unlawful intrusion.</li>
          <li>
            We limit access to your information on a “need to know” basis.
          </li>
          <li>
            We reveal only the last five digits of your credit card numbers when
            confirming an order. Of course, we transmit the entire credit card
            number to the appropriate credit card company during order
            processing.
          </li>
        </ul>
        <p>
          It is important for you to protect against unauthorized access to your
          password and to your computer. Be sure to sign off when finished using
          a shared computer.
        </p>
        <p>
          No system can guarantee absolute security, just as the finest lock can
          not guarantee physical security. However, we take every reasonable
          precaution to assure that your data is secure.
        </p>
      </article>
      <article>
        <h2 className="privacy-title">4. Children</h2>
        <p>
          We do not sell products or services to children. If you are under 18,
          you may use this site only with involvement of a parent or guardian.
        </p>
      </article>
      <article>
        <h2 className="privacy-title">5. Other Websites</h2>
        <p>
          Various Web sites may be linked to from this site. If you link to
          another site, your privacy depends on the policy of that site. We
          strongly urge you to check their privacy policy. Not all sites
          guarantee that they will not share your personally identifiable
          information with others.
        </p>
      </article>
      <article>
        <h2 className="privacy-title">6. Contact Us</h2>
        <p>
          If you would like to learn more about our privacy policy, or to access
          your personally identifiable information contained on our website, you
          may contact us at guesswhofootball+pp@gmail.com. You will be required
          to provide identifier information to assure that this information is
          not released to others. We reserve the right to modify this policy in
          the future. If we do so, notice will be posted on our home page.
        </p>
      </article>
      <article>
        <h2 className="privacy-title">7. Licence</h2>
        <ul>
          <li>
            We grant you a licence to access the content, information and
            services contained within our website for personal use only.
          </li>
          <li>
            This licence allows you to download and cache (using your browser)
            individual pages from our website.
          </li>
          <li>
            This licence does not allow you to download and modify individual
            pages or substantial parts of our website nor to make our website
            available via an intranet, where our website or a substantial part
            of it is hosted locally on the intranet in question.
          </li>
          <li>
            Our website design, layout, content or text cannot be copied, edited
            or otherwise manipulated without our express prior written
            permission.
          </li>
          <li>
            Our website cannot be placed within the frame-set of another site.
          </li>
          <li>
            Third parties are not allowed to “deep link” to pages within our
            website, without our express prior written permission. All links
            (unless expressly permitted by us) should be to the main index page
            of our website. Furthermore, the content of such links, whether
            graphic or text should not be misleading, false, derogatory or in
            any other way offensive.
          </li>
        </ul>
      </article>
      <article>
        <h2 className="privacy-title">8. Copyright</h2>
        <ul>
          <li>
            All content, databases, graphics, buttons, icons, logos, layouts and
            look &amp; feel are our copyright, unless expressly acknowledged as
            otherwise.
          </li>
          <li>
            The data mining, extraction or utilisation of product information
            from our website is not permitted without our express prior written
            permission.
          </li>
        </ul>
        <p>&nbsp;</p>
      </article>
      <article>
        <h2 className="privacy-title">
          9. Limitations and Exclusions of Liability
        </h2>
        <ul>
          <li>
            Where content and information is provided on the website without
            charge we exclude all liability for such content and information.
          </li>
          <li>
            All business losses (including, but not limited to) loss of profits,
            income, revenue, damage to goodwill, loss of other commercial
            contracts, other commercial opportunities are all exclude.
          </li>
          <li>
            All indirect, consequential or special losses or damage are all
            excluded.
          </li>
          <li>
            All other losses or damages not reasonably foreseeable at the time
            of the contract between you and us are also excluded.
          </li>
          <li>
            All losses relating to the loss or corruption of data, databases,
            systems, software or hardware are all excluded.
          </li>
          <li>
            These terms and conditions do not exclude or limit liability for
            death or personal injury caused by you or us.
          </li>
          <li>
            These terms and conditions do not exclude or limit liability for
            fraud or fraudulent misrepresentation caused by you or us.
          </li>
          <li>
            These terms and conditions do not exclude or limit liability where
            this conflicts with the applicable law for this jurisdiction.
          </li>
        </ul>
      </article>
      <article>
        <h2 className="privacy-title">10. Indemnity</h2>
        <p>
          By your use of our website you hereby indemnify us and undertake to
          keep us indemnified at all times now and in the future against all
          possible claims relating to any breach of these terms and conditions
          by you. Such indemnities to include, (but not be limited to) all costs
          legal and otherwise, all other expenses, damages or settlements
          arising from your breach of these terms and conditions.
        </p>
      </article>
      <article>
        <h2 className="privacy-title">11. Variation</h2>
        <p>
          We reserve the right to vary these terms & conditions at any time,
          without giving notice to you. Such varied terms and conditions shall
          automatically apply to the use of our website from the date of
          publication on our website.
        </p>
      </article>
      <article>
        <h2 className="privacy-title">12. Assignment</h2>
        <p>
          We reserve the right to assign our rights and also our obligations
          under these terms and conditions, without giving notice to you. This
          right of assignment shall only apply to us and shall not apply to you
          in any way.
        </p>
      </article>
      <article>
        <h2 className="privacy-title">13. Severability</h2>
        <p>
          The foregoing paragraphs, sub-paragraphs and clauses of these terms
          &amp; conditions shall be read and construed independently of each
          other. Should any part of this agreement or its paragraphs,
          sub-paragraphs or clauses be found invalid it shall not affect the
          remaining paragraphs, sub-paragraphs and clauses.
        </p>
      </article>
      <article>
        <h2 className="privacy-title">14. Waiver</h2>
        <p>
          Failure by us to enforce any accrued rights under these terms &amp;
          conditions is not to be taken as or deemed to be a waiver of those
          rights by us unless we acknowledge the waiver in writing.
        </p>
      </article>
      <article>
        <h2 className="privacy-title">15. Third Parties</h2>
        <p>
          These terms and conditions are between you and us. They do not apply
          to, or benefit any third party and are not reliant on any third party.
        </p>
      </article>
      <article>
        <h2 className="privacy-title">16. Entire Terms &amp; Conditions</h2>
        <p>
          These terms &amp; conditions set out the entire agreement and
          understanding between you and us.
        </p>
      </article>
      <article>
        <h2 className="privacy-title">17. Your Statutory Rights</h2>
        <p>Where acting as a consumer your statutory rights are unaffected.</p>
      </article>
    </div>
  );
}

export default Privacy;
